module.exports = __webpack_public_path__ + "img/send.84f16ee3.png";